import type { datadogRum } from "@datadog/browser-rum";

let isInitialized = false;
type DatadogRum = typeof datadogRum;

const noop = () => {};
const fallbackDatadogRum = {
  init: noop,
  setUser: noop,
  setGlobalContext: noop,
  addAction: noop,
  startSessionReplayRecording: noop,
  addError: noop,
  addFeatureFlagEvaluation: noop,
} as unknown as DatadogRum;

let datadogInstance: DatadogRum | null = null;

/**
 * Dynamically loads Datadog RUM and falls back to no-op methods when blocked.
 */
export const loadDatadog = async (): Promise<DatadogRum> => {
  if (datadogInstance) {
    return datadogInstance;
  }

  try {
    const { datadogRum } = await import("@datadog/browser-rum");
    datadogInstance = datadogRum;
    return datadogRum;
  } catch (error) {
    console.error("Failed to load Datadog RUM:", error);
    datadogInstance = fallbackDatadogRum;
    return fallbackDatadogRum;
  }
};

export const markDatadogAsInitialized = () => {
  isInitialized = true;
};

export const isDatadogInitialized = () => {
  return isInitialized;
};
